import blueprintIcon from "images/tileIcons/blueprint.svg";
import datasetIcon from "images/tileIcons/dataset.svg";
import modelIcon from "images/tileIcons/model.svg";
import runsIcon from "images/tileIcons/createRealAI.svg";
import consultingIcon from "aible/images/layers-purple.svg";
import projectIcon from "images/projects_new.svg";
import chatIcon from "images/chatbubble.svg";
import reportsIcon from "images/tileIcons/barGraphPurple.svg";
import rectangleIcon from "images/tileIcons/rectangleIcon.svg";
import globeIcon from "images/tileIcons/globe-light.svg";
import taskIcon from "images/Next-Icons/TaskIcon.svg";
import aiFeedbackIcon from "images/tileIcons/microchip-ai-purple.svg";
import chatAnalyticsIcon from "images/chart-mixed-light.svg";
import robotIcon from "images/Robot Light Icon.svg";
import MapIcon from "images/Map Light Icon.svg";
import browserIcon from "images/Browser Light Icon.svg";
import appsAgentsIcon from "images/agent.svg";
import monitoringIcon from "images/agent-analytics.svg";

import styles from "./utils.module.css";

import { VIEW_TYPE } from "containers/View/reducer";

const getStyles = (type) => {
  switch (type) {
    case "blueprint":
    case "blueprints":
    case "chat styles":
    case "chat templates":
    case "chat use cases":
    case "use cases":
      return {
        background: styles.backgroundBlueprint,
        text: styles.textBlueprint,
        icon: styles.iconBlueprint,
        image: blueprintIcon,
        color: "var(--blueprint-text)"
      };
    case "find data":
    case "data":
    case "dataset":
    case "datasets":
      return {
        background: styles.backgroundDataset,
        text: styles.textDataset,
        icon: styles.iconDataset,
        image: datasetIcon,
        color: "var(--dataset-text)"
      };
    case "model":
    case "models":
    case "model frontier":
    case "model frontiers":
    case "models - legacy":
      return {
        background: styles.backgroundModel,
        text: styles.textModel,
        icon: styles.iconModel,
        image: modelIcon,
        color: "var(--model-text)"
      };
    case "run":
    case "runs":
    case "realai":
      return {
        background: styles.backgroundModel,
        text: styles.textModel,
        icon: styles.iconModel,
        image: runsIcon,
        color: "var(--model-text)"
      };
    case "deployment":
    case "deployments":
    case "agents & a/z testing":
    case "apps":
    case VIEW_TYPE.DEPLOYMENTS:
    case VIEW_TYPE.CHAT_APPS:
      return {
        background: styles.backgroundDeployment,
        text: styles.textDeployment,
        icon: styles.iconDeployment,
        image: browserIcon,
        color: "var(--deployment-text)"
      };
    case "consulting":
    case "consultant":
    case "consultants":
    case "project":
    case "projects":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: consultingIcon,
        color: "var(--consulting-text)"
      };
    case VIEW_TYPE.AGENTS:
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: robotIcon,
        color: "var(--consulting-text)"
      };
    case VIEW_TYPE.APPS_AGENTS:
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: appsAgentsIcon,
        color: "var(--consulting-text)"
      };
    case "monitoring":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: monitoringIcon,
        color: "var(--consulting-text)"
      };
    case VIEW_TYPE.EXPLORATIONS:
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: projectIcon,
        color: "var(--consulting-text)"
      };
    case "new chat":
    case "chat":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: chatIcon,
        color: "var(--consulting-text)"
      };
    case "recipe":
    case "recipes":
      return {
        background: styles.backgroundDataset,
        text: styles.textDataset,
        icon: styles.iconDataset,
        image: datasetIcon,
        color: "var(--dataset-text)"
      };
    case "reports":
    case "report":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: reportsIcon,
        color: "var(--consulting-text)"
      };
    case "explorations":
    case "exploration":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: reportsIcon,
        color: "var(--consulting-text)"
      };
    case "hire consultants":
    case "job postings":
    case "find blueprints":
    case "manage jobs":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: rectangleIcon,
        color: "var(--consulting-text)"
      };
    case "overview":
    case "data sources":
    case "Data Sources":
      return {
        background: styles.backgroundConsulting,
        text: styles.textConsulting,
        icon: styles.iconConsulting,
        image: globeIcon,
        color: "var(--consulting-text)"
      };
    case "tasks":
      return {
        text: "Tasks",
        image: taskIcon
      };
    case "chat analytics":
    case "analytics":
      return {
        image: chatAnalyticsIcon
      };
    case "LLM Fine-Tuning":
    case "models & fine-tuning":
    case "models & AI feedback":
      return {
        background: styles.backgroundDataset,
        text: styles.textDataset,
        icon: styles.iconDataset,
        image: aiFeedbackIcon,
        color: "var(--dataset-text)"
      };
    case "agent templates":
      return {
        background: styles.backgroundBlueprint,
        text: styles.textBlueprint,
        icon: styles.iconBlueprint,
        color: "var(--blueprint-text)",
        image: MapIcon
      };
    default:
      return null;
  }
};

export default getStyles;
